import script from "./investList.vue?vue&type=script&lang=ts&setup=true"
export * from "./investList.vue?vue&type=script&lang=ts&setup=true"

import "./investList.vue?vue&type=style&index=0&id=4d36024c&lang=less"

const __exports__ = script;

export default __exports__